export function imageAltForImage(image) {
  return image.altText || image.caption || '';
}

export function imageAltForItem(item) {
  const { computedValues } = item;
  if (computedValues) {
    if (item.type === 'video') {
      return computedValues.headline;
    } if (computedValues.teaseImage) {
      return imageAltForImage(computedValues.teaseImage);
    }
  }
  return '';
}
